import {
  Badge,
  Button,
  Card,
  Checkbox,
  Dropdown,
  Image,
  Tag,
  Tooltip,
} from 'antd';
import { isEmpty } from 'lodash';
import { useContext } from 'react';
import Countdown from 'react-countdown';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { AppContext } from '../../../../../AppContext';
import { ReactComponent as CommentIcon } from '../../../../../assets/svg/comment-dots-solid.svg';
import { ReactComponent as MoreIcon } from '../../../../../assets/svg/ellipsis-vertical-solid.svg';
import { ReactComponent as LocationIcon } from '../../../../../assets/svg/location-dot-solid.svg';
import {
  CANCELLATION_TYPE,
  DATE_FORMATS,
  DELIVERY_TYPE,
  EXPRESS_DELIVERY_EMOJI,
  EXPRESS_DELIVERY_TOOLTIP_TEXT,
  FULFILLMENT_STATUS,
  LIBRARY_ALL_DELIVERY_TABLE_ACTIONS_OPTIONS,
  NEW_ORDER_TABLE_ACTIONS_OPTIONS,
  ORDER_STATUS,
  ORDER_TAG_TYPES,
  QUICK_DELIVERY_EMOJI,
  QUICK_DELIVERY_TOOLTIP_TEXT,
  ROUTES,
  USER_ROLES,
} from '../../../../../common/constants';
import {
  formatDate,
  getAttachmentSource,
  getRowClassName,
  hasPreOrderToy,
  isSalesUser,
  renderer,
} from '../../../../../common/utils';
import ChallanDownloadButton from '../../../../../components/ChallanDownloadButton';
import OrderDynamicTags from '../../../../../components/OrderDynamicTags';
import BigToyIcon from '../../../../../modules/orders/modules/new/components/BigToyIcon';
import StatusFlag from '../../../../../modules/orders/modules/new/components/OrderTagRenderer';
import UserSelect from '../../../../../modules/payments/modules/endUser/components/UserSelect';

const AllOrderCard = ({
  thresholdData,
  order,
  infiniteScrollRef,
  handleOrderChange,
  setOrder,
  setIsAllOrderItemModalOpen,
  isNewPath,
  setIsNotePrompts,
  setIsOrderAction,
  handleChallanDownload,
  isChallanLoading,
  handleChallanReset,
  isResetLoading,
  setVisible,
  setToyImages,
  handleSelectOrders,
  selectedOrders,
  setIsReasonPrompt,
  isAdmin,
  isAssignDelPartnerTab,
  setDeliveryPartnerData,
  setIsDeliveryPartnerPrompts,
  isCombinedOrder,
  hasUpdatePermission,
  setIsAddCommentModalOpen,
  setIsOrderStatusModalOpen,
  playNotificationSound,
  criticalOrdersRef,
  isAllDelivery,
  isLibrary,
  showBlink,
  renderBlinkingDotEl,
  showNote,
  setIsCommentPrompts,
  openGoogleMaps,
  setIsDeliveredPrompt,
  checkDeliveryPartner,
}) => {
  const handleMenuClick = (e) => {
    handleOrderChange(e?.key, order);
  };
  const history = useHistory();
  const {
    state: {
      currentUser,
      commonPermissions: { isLibraryPermission },
    },
  } = useContext(AppContext);

  let selectedValue = null;
  if (
    order?.status === ORDER_STATUS?.CANCELLED?.value ||
    order?.status === ORDER_STATUS?.CONFIRMED?.value
  ) {
    if (order?.status === ORDER_STATUS?.CANCELLED?.value) {
      selectedValue = FULFILLMENT_STATUS?.UNFULFILLED?.value;
    } else {
      selectedValue = FULFILLMENT_STATUS?.FULFILLED?.value;
    }
  } else {
    selectedValue = null;
  }
  const setMenuProps = () => {
    if (isNewPath) {
      return {
        items: NEW_ORDER_TABLE_ACTIONS_OPTIONS?.map((item) => ({
          label: item?.label,
          key: item?.value,
          disabled:
            item?.value === FULFILLMENT_STATUS.FULFILLED.value &&
            hasPreOrderToy(order),
        })),
        onClick: handleMenuClick,
        disabled: !!selectedValue,
      };
      // eslint-disable-next-line no-else-return
    } else {
      return {
        items: LIBRARY_ALL_DELIVERY_TABLE_ACTIONS_OPTIONS?.map((item) => ({
          label: item?.label,
          key: item?.value,
        })),
        onClick: handleMenuClick,
        disabled:
          order?.status === ORDER_STATUS?.CANCELLED?.value ||
          order?.status === ORDER_STATUS?.DELIVERED?.value ||
          order?.status === ORDER_STATUS?.SHIPPED?.value ||
          order?.status === ORDER_STATUS?.NOT_DELIVERED?.value,
      };
    }
  };

  const { firstName, lastName, id, userNumber } = order?.deliveryPartner || {};
  const assignedDeliveryPartner = {
    firstName,
    lastName,
    id,
    userNumber,
  };

  const menuProps = isNewPath
    ? {
        items: NEW_ORDER_TABLE_ACTIONS_OPTIONS?.map((item) => ({
          label: item?.label,
          key: item?.value,
        })),
        onClick: handleMenuClick,
        disabled: !!selectedValue,
      }
    : {
        items: LIBRARY_ALL_DELIVERY_TABLE_ACTIONS_OPTIONS?.map((item) => ({
          label: item?.label,
          key: item?.value,
        })),
        onClick: handleMenuClick,
        disabled:
          order?.status === ORDER_STATUS?.CANCELLED?.value ||
          order?.status === ORDER_STATUS?.DELIVERED?.value ||
          order?.status === ORDER_STATUS?.SHIPPED?.value ||
          order?.status === ORDER_STATUS?.NOT_DELIVERED?.value,
      };

  const shippedAttachments =
    order?.deliveryAttachments?.filter(
      (attachment) =>
        attachment?.deliveryAttachmentsType === ORDER_STATUS?.SHIPPED?.value,
    ) || [];

  const deliveredAttachments =
    order?.deliveryAttachments?.filter((attachment) =>
      [ORDER_STATUS?.DELIVERED?.value, null]?.includes(
        attachment?.deliveryAttachmentsType,
      ),
    ) || [];

  const nextStatusTime = new Date(order?.nextStatusTime)?.getTime();
  const userData = order?.user;

  return (
    <Card
      className={`ml-12 mr-12 mb-24 mt-12 mobile-card ${getRowClassName(
        order,
        thresholdData,
        playNotificationSound,
        criticalOrdersRef,
      )}`}
      title={
        <div className="overflow-scroll no-scroll-bar align-center">
          {isAdmin &&
            !isSalesUser(currentUser) &&
            typeof handleSelectOrders === 'function' && (
              <Checkbox
                className="mr-12"
                onClick={(e) => e.stopPropagation()}
                checked={selectedOrders?.includes(order?.id)}
                onChange={(e) => {
                  e.stopPropagation();
                  handleSelectOrders(order?.id);
                }}
              />
            )}
          {showBlink && renderBlinkingDotEl(order?.status)}
          {order?.orderNumber}
          {!isCombinedOrder && (
            <div
              onClick={(e) => e?.stopPropagation()}
              onTouchStart={(e) => e?.stopPropagation()} // required for mobile
              className="mobile-emoji-wrapper"
            >
              {order?.isExpressDelivery && !order?.isQuickDelivery && (
                <Tooltip
                  title={EXPRESS_DELIVERY_TOOLTIP_TEXT}
                  placement="top"
                  zIndex={9999}
                  trigger={['click']}
                >
                  <Tag color="red" className="ml-8 mr-0 express-delivery-icon">
                    {EXPRESS_DELIVERY_EMOJI}
                  </Tag>
                </Tooltip>
              )}

              {order?.isQuickDelivery && (
                <Tooltip
                  title={QUICK_DELIVERY_TOOLTIP_TEXT}
                  placement="top"
                  zIndex={9999}
                  trigger={['click']}
                >
                  <Tag color="yellow" className="ml-8 mr-0 quick-delivery-icon">
                    {QUICK_DELIVERY_EMOJI}
                  </Tag>
                </Tooltip>
              )}
            </div>
          )}
        </div>
      }
      extra={
        <div className="d-flex align-center">
          <Badge
            color={ORDER_STATUS?.[order?.status]?.color}
            text={ORDER_STATUS?.[order?.status]?.text}
            className="mr-16 ml-16"
          />
          {!isAssignDelPartnerTab && (isAdmin ? isNewPath : true) && (
            <>
              <span>
                {order?.cancellationData?.type ===
                  CANCELLATION_TYPE?.LIBRARY?.value && (
                  <span className="action-button">
                    <CommentIcon
                      className="mr-16 pointer svg-icon"
                      onClick={(e) => {
                        e?.stopPropagation();
                        setIsNotePrompts(true);
                        setOrder(order);
                        setIsOrderAction(true);
                      }}
                    />
                  </span>
                )}
              </span>
              <div onClick={(e) => e?.stopPropagation()} className="d-flex">
                <Dropdown
                  getPopupContainer={(trigger) => trigger?.parentNode}
                  menu={setMenuProps()}
                  disabled={
                    order.transferOrderItemCount !== 0 &&
                    order.transferOrderItemCount !== null
                  }
                >
                  <MoreIcon
                    className="pointer mobile-svg-icon"
                    onClick={(e) => {
                      e?.stopPropagation();
                    }}
                  />
                </Dropdown>
              </div>
            </>
          )}
        </div>
      }
      ref={infiniteScrollRef}
      onClick={() => {
        setOrder(order);
        setIsAllOrderItemModalOpen(true);
      }}
    >
      <div>
        <div className="mb-8">
          <span className="mobile-card-label">Has Large Toy: </span>
          <span>
            {order?.metadata?.isContainBigToy ? <BigToyIcon /> : 'No Large Toy'}
          </span>
        </div>

        <div className="mb-8">
          <span className="mobile-card-label">Has Pre-Order Toy: </span>
          <span>
            {hasPreOrderToy(order) && (
              <StatusFlag type={ORDER_TAG_TYPES.PRE_ORDER} />
            )}{' '}
          </span>
        </div>
        <div className="mb-8">
          <span className="mobile-card-label">Quantity: </span>
          <span>{order?.orderItemCount || 'No Quantity'}</span>
        </div>
        <div className="mb-8">
          <span className="mobile-card-label">Tags:  </span>
          {order?.orderTags?.length > 0 ? <OrderDynamicTags tags={order?.orderTags} noLeadingMargin /> : ' -'}
        </div>

        <div className="mb-8">
          <span className="mobile-card-label">Total Orders Count: </span>
          <span>{order?.totalOrdersCount ?? 'No Total Orders Count'}</span>
        </div>

        {!isCombinedOrder && !isAssignDelPartnerTab && (
          <>
            <div className="mb-8">
              <span className="mobile-card-label">
                {isNewPath ? 'Order Packaging SLA:' : 'Order SLA:'}{' '}
              </span>
              <span>
                {order?.nextStatusTime
                  ? formatDate(order?.nextStatusTime, DATE_FORMATS?.WITH_TIME)
                  : 'N/A'}
              </span>
            </div>
            <div className="mb-8">
              <span className="mobile-card-label">
                {isNewPath ? 'Order Packaging Time Left:' : 'Order Time Left:'}{' '}
              </span>
              <span>
                <div>
                  {!isEmpty(order?.nextStatusTime) &&
                  (!isNewPath
                    ? order?.status !== ORDER_STATUS?.DELIVERED?.value
                    : true) ? (
                    <Countdown date={nextStatusTime} renderer={renderer} />
                  ) : (
                    'N/A'
                  )}
                </div>
              </span>
            </div>
          </>
        )}

        {!isCombinedOrder && isAssignDelPartnerTab && (
          <>
            <div className="mb-8">
              <span className="mobile-card-label">
                {order?.status === ORDER_STATUS.CONFIRMED.value
                  ? 'Rider Assignment SLA: '
                  : 'Delivery SLA: '}
              </span>
              <span>
                {order?.nextStatusTime
                  ? formatDate(order?.nextStatusTime, DATE_FORMATS?.WITH_TIME)
                  : 'N/A'}
              </span>
            </div>
            <div className="mb-8">
              <span className="mobile-card-label">
                {order?.status === ORDER_STATUS.CONFIRMED.value
                  ? 'Rider Assignment Time Left: '
                  : 'Delivery Time Left: '}
              </span>
              <span>
                <div>
                  {!isEmpty(order?.nextStatusTime) &&
                  (!isNewPath
                    ? order?.status !== ORDER_STATUS?.DELIVERED?.value
                    : true) ? (
                    <Countdown date={nextStatusTime} renderer={renderer} />
                  ) : (
                    'N/A'
                  )}
                </div>
              </span>
            </div>
          </>
        )}

        <div className="mb-8">
          <span className="mobile-card-label">Delivery Type: </span>
          <span>
            {DELIVERY_TYPE?.[order?.deliveryType]?.label || 'No Delivery Type'}
          </span>
        </div>
        <div className="mb-8">
          <span className="mobile-card-label">User Name: </span>
          <>
            {userData?.firstName || userData?.lastName ? (
              <div className="table-data-with-id">{`${
                userData?.firstName ? userData?.firstName : ''
              } ${userData?.lastName ? userData?.lastName : ''}`}</div>
            ) : (
              '-'
            )}
            {userData?.userNumber ? (
              <div className="font-size-12">({userData?.userNumber})</div>
            ) : (
              ''
            )}
          </>
        </div>

        {isAdmin && (
          <div className="mb-8">
            <span className="mobile-card-label">Library Name: </span>
            <div
              className={`${
                isLibraryPermission &&
                order?.library?.id &&
                !isSalesUser(currentUser) &&
                'link pointer'
              }`}
              onClick={(e) => {
                e.stopPropagation();
                if (
                  isLibraryPermission &&
                  order?.library?.id &&
                  !isSalesUser(currentUser)
                ) {
                  history?.push(
                    `${ROUTES?.MASTER_LISTS}${ROUTES?.LIBRARY}${ROUTES?.BASIC_DETAILS}/view/${order?.library?.id}/${order?.library?.libraryNumber}`,
                  );
                }
              }}
            >
              {order?.library?.name ? (
                <div className="table-data-with-id">{order?.library?.name}</div>
              ) : (
                '-'
              )}
              {order?.library?.libraryNumber ? (
                <div className="font-size-12">
                  ({order?.library?.libraryNumber})
                </div>
              ) : (
                ''
              )}
            </div>
          </div>
        )}
        {isAdmin && !isCombinedOrder && (
          <div className="mb-8">
            <span className="mobile-card-label">City: </span>
            <span>{order?.library?.city || 'No City'}</span>
          </div>
        )}
        <div className="mb-8">
          <span className="mobile-card-label">Pincode: </span>
          <span>{order?.pincode?.pincode || 'No Pincode'}</span>
        </div>
        <div className="mb-8">
          <span className="mobile-card-label">Is First Order: </span>
          <span>
            {' '}
            {order?.isFirstOrder ? (
              <StatusFlag type={ORDER_TAG_TYPES.FIRST_ORDER} />
            ) : (
              'No'
            )}
          </span>
        </div>

        <div className="mb-8">
          <span className="mobile-card-label">Is Delayed Order: </span>
          <span>
            {' '}
            {order?.delayedInConfirmed || order?.delayedInShipped ? (
              <StatusFlag
                type={
                  order?.delayedInShipped
                    ? ORDER_TAG_TYPES.DELAYED_SHIPMENT
                    : ORDER_TAG_TYPES.DELAYED_CONFIRMED
                }
              />
            ) : (
              'No'
            )}
          </span>
        </div>

        {!isAssignDelPartnerTab && (
          <div className="mb-8">
            <span className="mobile-card-label">Delay Reason: </span>
            <span>
              {!isEmpty(order?.metadata?.delayReason) ? (
                <Tooltip title="View reason" placement="top" zIndex={4}>
                  <CommentIcon
                    className="mr-16 pointer svg-icon"
                    onClick={(e) => {
                      e.stopPropagation();
                      setIsReasonPrompt(true);
                      setOrder(order);
                      setIsOrderAction(true);
                    }}
                  />
                </Tooltip>
              ) : (
                <span className="mr-24">-</span>
              )}
            </span>
          </div>
        )}

        <div className="mb-8">
          <span className="mobile-card-label">Delivery Partner Name: </span>
          <span>
            {order?.deliveryPartner?.firstName ||
            order?.deliveryPartner?.lastName ? (
              <span className="table-data-with-id">{`${
                order?.deliveryPartner?.firstName
                  ? order?.deliveryPartner?.firstName
                  : ''
              } ${
                order?.deliveryPartner?.lastName
                  ? order?.deliveryPartner?.lastName
                  : ''
              }`}</span>
            ) : (
              'No Delivery Partner'
            )}
            {order?.deliveryPartner?.userNumber ? (
              <>
                <span className="font-size-12">
                  ({order?.deliveryPartner?.userNumber})
                </span>
                {!isSalesUser(currentUser) &&
                  isAllDelivery &&
                  !isCombinedOrder && (
                    <Tooltip title="View Location" placement="top" zIndex={4}>
                      <LocationIcon
                        onClick={(e) => {
                          e?.stopPropagation();
                          const [lng, lat] = order?.latLong?.coordinates || [];
                          openGoogleMaps(lat, lng, order?.deliveryPartner?.id);
                        }}
                        className="ml-16 pointer svg-icon"
                      />{' '}
                    </Tooltip>
                  )}
              </>
            ) : (
              ''
            )}
          </span>
        </div>

        <div className="mb-8">
          <span className="mobile-card-label">Placed On: </span>
          <span>{formatDate(order?.createdAt, DATE_FORMATS?.WITH_TIME)}</span>
        </div>
        <div className="mb-8">
          <span className="mobile-card-label">
            {isNewPath ? 'Estimated Shipping Date:' : 'Delivered On:'}{' '}
          </span>
          <span>
            {formatDate(order?.deliveredOn, DATE_FORMATS?.WITH_TIME) || '-'}
          </span>
        </div>

        {!isNewPath && (
          <>
            <div className="mb-8">
              <span className="mobile-card-label">Shipped Attachments: </span>
              <span>
                {shippedAttachments?.length > 0 ? (
                  <Image
                    preview={{
                      visible: false,
                    }}
                    width={20}
                    height={20}
                    src={getAttachmentSource(shippedAttachments?.[0])}
                    onClick={(e) => {
                      e?.stopPropagation();
                      setVisible(true);
                      setToyImages(shippedAttachments);
                    }}
                    className="pointer"
                  />
                ) : (
                  <span>No Images</span>
                )}
                {shippedAttachments?.length > 1
                  ? ` + ${shippedAttachments?.length - 1}`
                  : ''}
              </span>
            </div>
            <div className="mb-8">
              <span className="mobile-card-label">Delivered Attachments: </span>
              <span>
                {deliveredAttachments?.length > 0 ? (
                  <Image
                    preview={{
                      visible: false,
                    }}
                    width={20}
                    height={20}
                    src={getAttachmentSource(deliveredAttachments?.[0])}
                    onClick={(e) => {
                      e?.stopPropagation();
                      setVisible(true);
                      setToyImages(deliveredAttachments);
                    }}
                    className="pointer"
                  />
                ) : (
                  <span>No Images</span>
                )}
                {deliveredAttachments?.length > 1
                  ? ` + ${deliveredAttachments?.length - 1}`
                  : ''}
              </span>
            </div>

            {showNote && (
              <div className="mb-8">
                <span className="mobile-card-label">Note: </span>
                <span
                  className="action-button"
                  onClick={(e) => e?.stopPropagation()}
                >
                  {order?.cancellationData || order?.comment?.comment ? (
                    <Tooltip placement="top" zIndex={4}>
                      <CommentIcon
                        className="mr-16 pointer svg-icon"
                        onClick={() => {
                          setIsNotePrompts(true);
                          setOrder(order);
                          setIsOrderAction(true);
                        }}
                      />
                    </Tooltip>
                  ) : (
                    <span className="mr-24">-</span>
                  )}
                  {hasUpdatePermission && (
                    <Button
                      type="primary"
                      size="small"
                      className="table-action-primary-btn"
                      onClick={() => {
                        setIsCommentPrompts(true);
                        setOrder(order);
                        setIsOrderAction(true);
                      }}
                      disabled={
                        order?.comment?.isResolved ||
                        order?.status !== ORDER_STATUS?.CANCELLED?.value
                      }
                    >
                      Resolve
                    </Button>
                  )}
                </span>
              </div>
            )}
          </>
        )}

        {isAssignDelPartnerTab && (
          <>
            <div className="dashed-line" />
            <div onClick={(e) => e?.stopPropagation()}>
              <UserSelect
                isLibrary={isLibrary}
                size="small"
                className="user-select"
                placeholder="Select Delivery Partner"
                showAction={['click']}
                value={id || null}
                userData={id ? assignedDeliveryPartner : null}
                roles={USER_ROLES?.DELIVERY?.key}
                onChange={(value, user) => {
                  checkDeliveryPartner(user, order);
                }}
                allowClear={false}
              />
            </div>
          </>
        )}
        {!isNewPath && !isAdmin && !isAssignDelPartnerTab && (
          <>
            <div className="dashed-line" />
            <div className="d-flex justify-between flex-wrap gap-10">
              <ChallanDownloadButton
                order={order}
                handleChallanDownload={handleChallanDownload}
                isChallanLoading={isChallanLoading}
                className="mr-16"
                size="middle"
              />
              <Button
                loading={isResetLoading?.[order?.id]}
                onClick={(e) => {
                  e?.stopPropagation();
                  handleChallanReset(order?.id);
                }}
                disabled={
                  ![
                    ORDER_STATUS?.READY_TO_SHIP?.value,
                    ORDER_STATUS?.CONFIRMED?.value,
                  ]?.includes(order?.status)
                }
              >
                Reset Challan
              </Button>
            </div>
          </>
        )}

        {isAdmin && !isNewPath && !isAssignDelPartnerTab && (
          <>
            <div className="dashed-line" />
            <div
              className="d-flex justify-between flex-wrap gap-10"
              onClick={(e) => e.stopPropagation()}
            >
              {hasUpdatePermission && (
                <Button
                  type="primary"
                  size="small"
                  className="custom-buttons"
                  onClick={(e) => {
                    e?.stopPropagation();
                    setIsAddCommentModalOpen(true);
                    setOrder(order);
                    setIsOrderAction(true);
                  }}
                  disabled={
                    order?.status === ORDER_STATUS?.DELIVERED?.value ||
                    order?.status === ORDER_STATUS?.CANCELLED?.value
                  }
                >
                  Cancel
                </Button>
              )}
              {!isSalesUser(currentUser) && (
                <>
                  <ChallanDownloadButton
                    order={order}
                    handleChallanDownload={handleChallanDownload}
                    isChallanLoading={isChallanLoading}
                    className="custom-buttons"
                  />
                  <Button
                    type="primary"
                    size="small"
                    className="custom-buttons"
                    onClick={() => handleChallanReset(order?.id)}
                    loading={isResetLoading?.[order?.id]}
                    disabled={
                      ![
                        ORDER_STATUS?.READY_TO_SHIP?.value,
                        ORDER_STATUS?.CONFIRMED?.value,
                      ]?.includes(order?.status)
                    }
                  >
                    Reset Challan
                  </Button>
                </>
              )}

              <Button
                type="primary"
                size="small"
                className="custom-buttons"
                onClick={() => {
                  setOrder(order);
                  setIsOrderAction(true);
                  setIsOrderStatusModalOpen(true);
                }}
              >
                Order Status Logs
              </Button>
            </div>
          </>
        )}

        {isAllDelivery &&
          currentUser?.roles?.includes(USER_ROLES?.SUPER_ADMIN?.key) && (
            <div className="mt-10">
              <Button
                type="primary"
                size="small"
                className="custom-buttons"
                onClick={(e) => {
                  e?.stopPropagation();
                  setIsDeliveredPrompt(true);
                  setOrder(order);
                  setIsOrderAction(true);
                }}
                disabled={
                  order?.status === ORDER_STATUS?.PLACED?.value ||
                  order?.status === ORDER_STATUS?.CANCELLED?.value ||
                  order?.status === ORDER_STATUS?.DELIVERED?.value ||
                  order?.status === ORDER_STATUS?.PROCESSING?.value ||
                  order?.status === ORDER_STATUS?.AWAITING_PAYMENT?.value
                }
              >
                Mark as Delivered
              </Button>
            </div>
          )}
      </div>
    </Card>
  );
};

export default AllOrderCard;
